import { useStats } from "@/hooks/useStats";

export default function Stats() {
  const { stats } = useStats();

  if (stats.length === 0) return null;

  const items = stats.map((s) => ({ value: s.value, label: s.label, icon: s.icon }));

  return (
    <section className="relative z-10 -mt-1 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 -mt-12 md:-mt-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {items.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-50 rounded-lg p-5 md:p-7 text-center border border-background-200"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className={`${stat.icon} text-xl md:text-2xl`}></i>
              </span>
              <p className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
                {stat.value}
              </p>
              <p className="mt-1 text-sm md:text-base text-foreground-600">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}